class Roles
{
    static ADMIN = 'admin' ;
    static GUEST = 'guest' ;
    static READ  = 'read'  ;
    static WRITE = 'write' ;
}

export default Roles ;


// WEBPACK FOOTER //
// ./src/app/net/auth/Roles.js